import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
const FooterOfKas = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            RT_para$,
            RT_paraID,
            RT_paraRR,
            RT_koyparadanID,
            RT_koyparadan$,
            RT_koyparadarhinanRRR,
            RT_koyparadarhinanID,
            RT_koyparadarhinan$,
            RT_koyparadanRRR,
            PD_RR_IQD,
            PD_RR_$,
            MM_RR_IQD,
            MM_RR_$,
            RT_KoyKriniRR
          } = value;
          return (
            <>
              {/* second row */}
              <br />
              <div className="row">
                <div className="col-lg-12 col-12">
                  <div className="row ">
                    <div className="col-lg-2  col-3">
                      <h3 className="bg-white tc">
                        <NumberFormat
                          value={Number(RT_koyparadan$).toFixed(2)}
                          className="bg-white f4 font-weight-bold  tc border-0"
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </h3>
                    </div>
                    <div className="col-lg-3 col-3">
                      <h3 className="text-warning tc ">$کۆی پارەدان</h3>
                    </div>

                    <div className="col-lg-2 col-3">
                      <h3 className="bg-white tc">
                        <NumberFormat
                          value={Number(RT_koyparadarhinan$).toFixed(2)}
                          prefix={"$"}
                          className="bg-white f4 font-weight-bold  tc border-0"
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </h3>
                    </div>
                    <div className="col-lg-1 col-3">
                      <h3 className="text-warning tc">مافی کۆمپانا</h3>
                    </div>

                    <div className="col-lg-2 col-2">
                      <h3 className="bg-white tc">
                        <NumberFormat
                          value={Number(RT_para$).toFixed(2)}
                          prefix={"$"}
                          className="bg-white f4 font-weight-bold  tc border-0"
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </h3>
                    </div>
                    <div className="col-lg-2 col-2">
                      <h3 className="text-warning tc">
                        {RT_para$ >= 0 && RT_paraID >= 0
                          ? "قەرزی ئێمە"
                          : "قەرزی کۆمپانیا"}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>

              {/* third row */}
              <div className="row">
                <div className="col-lg-12 col-12">
                  <div className="row ">
                    <div className="col-lg-2 col-2 ">
                      <h3 className="bg-white tc">
                        <NumberFormat
                          value={Number(RT_koyparadanID).toFixed(2)}
                          className=" f4 font-weight-bold  tc border-0"
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </h3>
                    </div>
                    <div className="col-lg-3 col-4">
                      <h3 className="text-warning tc">IDکۆی پارەدان</h3>
                    </div>

                    <div className="col-lg-2 col-3">
                      <h3 className="bg-white tc">
                        <NumberFormat
                          value={Number(RT_koyparadarhinanID).toFixed(2)}
                          prefix={"ID"}
                          className="bg-white f4 font-weight-bold  tc border-0"
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </h3>
                    </div>

                    <div className="col-lg-1 col-3"></div>

                    <div className="col-lg-2 col-3">
                      <h3 className="bg-white tc">
                        <NumberFormat
                          value={Number(RT_paraID).toFixed(2)}
                          prefix={"ID"}
                          className="bg-white f4 font-weight-bold  tc border-0"
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </h3>
                    </div>

                    <div className="col-lg-1 col-3"></div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-12 col-12">
                  <div className="row ">
                    <div className="col-lg-2 col-2 ">
                      <h3 className="bg-white tc">
                        <NumberFormat
                          value={Number(RT_koyparadanRRR).toFixed(2)}
                          className=" f4 font-weight-bold  tc border-0"
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </h3>
                    </div>
                    <div className="col-lg-3 col-4">
                      <h3 className="text-warning tc">Rکۆی پارەدان</h3>
                    </div>

                    <div className="col-lg-2 col-3">
                      <h3 className="bg-white tc">
                        <NumberFormat
                          value={Number(RT_koyparadarhinanRRR).toFixed(2)}
                          prefix={"R"}
                          className="bg-white f4 font-weight-bold  tc border-0"
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </h3>
                      <h3 className="bg-white tc">
                        <h5 className="text-warning tc">گران</h5>
                        <NumberFormat
                          value={Number(RT_KoyKriniRR).toFixed(2)}
                          prefix={"R"}
                          className="bg-white f4 font-weight-bold  tc border-0"
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </h3>
                    </div>

                    <div className="col-lg-1 col-3"></div>

                    <div className="col-lg-2 col-3">
                      <h3 className="bg-white tc">
                        <NumberFormat
                          value={RT_paraRR}
                          prefix={"R"}
                          className="bg-white f4 font-weight-bold  tc border-0"
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </h3>
                    </div>

                    <div className="col-lg-1 col-3"></div>
                  </div>
                </div>
              </div>

              <div className="row text-center">
                <div className="col-3">
                  <h3 className="text-warning ">پارەدانR$</h3>
                  <h3 className="bg-white tc">
                  <NumberFormat
                    value={Number(PD_RR_$).toFixed(2)}
                      prefix={"$"}
                    className="bg-white f4 font-weight-bold  tc border-0"
                    displayType={"text"}
                    thousandSeparator={true}
                    />
                  </h3>
                </div>
                <div className="col-3">
                  <h3 className="text-warning tc">پارەدانRIQD</h3>
                  <h3 className="bg-white tc">
                  <NumberFormat
                    value={Number(PD_RR_IQD).toFixed(2)}
                    prefix={"ID"}
                    className="bg-white f4 font-weight-bold  tc border-0"
                    displayType={"text"}
                    thousandSeparator={true}
                    />
                  </h3>
                </div>
                <div className="col-3">
                  <h3 className="text-warning tc">مافR$</h3>
                  <h3 className="bg-white tc">
                  <NumberFormat
                    value={Number(MM_RR_$).toFixed(2)}
                      prefix={"$"}
                    className="bg-white f4 font-weight-bold  tc border-0"
                    displayType={"text"}
                    thousandSeparator={true}
                    />
                  </h3>
                </div>
                <div className="col-3">
                  <h3 className="text-warning tc">مافRIQD</h3>
                  <h3 className="bg-white tc">
                  <NumberFormat
                    value={Number(MM_RR_IQD).toFixed(2)}
                    prefix={"ID"}
                    className="bg-white f4 font-weight-bold  tc border-0"
                    displayType={"text"}
                    thousandSeparator={true}
                    />
                  </h3>
                </div>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default FooterOfKas;
